import React from 'react';
// import OwnerModal from './OwnerModal';
import { Box, IconButton } from '@material-ui/core';
import { notifySuccess, notifyError } from '../../../components/Messages/Notification';
import { Visibility as ViewIcon } from '@material-ui/icons';
import Button from '../../../components/Buttons/Button';
import ClientGrid from '../../../components/ClientGrid/ClientGrid';
import { createNote } from '../../../services/AccountNoteService';
import NoteModal from '../../../components/Modals/NoteModal';
import {
  pbDateTime,
  pbDateTimeSorter,
  htmlString,
} from '../../../components/ClientGrid/CellRenderer';

export default function NoteTable({
  accountId,
  list: rows,
  set: setRows,
  isPendingClient: isPendingClient,
}) {
  // const classes = useStyles();
  const [rowData, setRowData] = React.useState({});
  const [validation, setValidation] = React.useState({});
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState({
    save: false,
  });

  const GridButtons = ({ tableManager, value, data, column, colIndex, rowIndex }) => {
    return (
      <div>
        <div style={{ padding: 5 }}>
          <IconButton
            aria-label="view"
            onClick={() => {
              handleOpen(data);
            }}
          >
            <ViewIcon style={{ height: 20, width: 20 }} />
          </IconButton>
        </div>
      </div>
    );
  };

  const columns = [
    // {
    //   id: '',
    //   field: '',
    //   width: '40px',
    //   cellRenderer: GridButtons,
    // },
    {
      id: 'subject',
      field: 'subject',
      label: 'Subject',
      visible: true,
    },
    {
      id: 'note',
      field: 'note',
      label: 'Note',
      cellRenderer: htmlString,
      width: '500px',
      visible: true,
    },
    {
      id: 'createdBy',
      field: 'createdBy',
      label: 'Created By',
      visible: true,
    },
    {
      id: 'createdAt',
      field: 'createdAt',
      label: 'Created At',
      visible: true,
      cellRenderer: pbDateTime,
      sort: pbDateTimeSorter,
    },
  ];

  const handleOpen = (data) => {
    if (!data) {
      //ADD default values
      data = {
        noteType: '',
        subject: '',
        note: '',
      };
    }

    setRowData(data);
    setOpen(true);
  };

  const handleClose = async (data, isEdit) => {
    if (!data) {
      setValidation({});
      setOpen(false);
      return;
    }
    data.accountId = accountId;
    try {
      let valid = true;

      setValidation({
        noteType: !data.noteType,
        subject: !data.subject,
        note: !data.note,
      });

      if (!data.noteType) {
        notifyError('Note Type is required.');
        valid = false;
      }
      if (!data.subject) {
        notifyError('Subject is required.');
        valid = false;
      }
      if (!data.note) {
        notifyError('Note is required.');
        valid = false;
      }

      if (!valid) {
        return;
      }

      setLoading({ ...loading, save: true });

      //ADD
      data.linkId = accountId;
      const { note } = await createNote(data);
      setRows([note, ...rows]);
      notifySuccess('New note has been added.');

      setValidation({});
      setOpen(false);
    } catch (error) {
      setLoading({ ...loading, save: false });
      notifyError(error.message);
      console.error(error);
    }

    setLoading({ ...loading, save: false });
  };

  const getCsvData = async () => {
    if (rows.length === 0) {
      return [];
    }
    let rowsCopy = [...rows];
    return rowsCopy;
  };

  return (
    <div className="page-c" style={{ marginTop: -50 }}>
      <Box component="search-c">
        {!isPendingClient && (
          <div className="grd-row nm">
            <div className="grd-cell-none">
              <Button
                type="plus"
                label="Add New Note"
                onClick={() => {
                  handleOpen();
                }}
              />
            </div>
          </div>
        )}
      </Box>
      <div className="mt-20">
        <ClientGrid
          title="Notes"
          rowIdField="notesId"
          columns={columns}
          rows={rows}
          getCsvData={getCsvData}
          isLoading={loading}
          setRows={setRows}
        />
      </div>
      {open && (
        <NoteModal
          onClose={handleClose}
          open={open}
          value={rowData}
          validation={validation}
          loading={loading.save}
        ></NoteModal>
      )}
    </div>
  );
}
